<template>
    <v-app id="inspire" class="container-width">
        <navigation-drawer />
        <router-view  class="container-width" />
        <footer-layout />
    </v-app>
</template>

<script>
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import Footer from "@/components/Footer.vue";
export default {
    name: "App",
    components: {
        "navigation-drawer": NavigationDrawer,
        "footer-layout": Footer,
    },
    data: () => ({
        //
    }),
};
</script>
<style>
@import "@/assets/_global.scss";
/* .row {
    display: flex;
} */


.container-width {
    min-width: 1200px !important;
    width: 100% !important;
}
</style>
